var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScimplifyLogo8A1Aba1D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3202,
    height: 1051,
    viewBox: "0 0 3202 1051",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2 0.0999756H0V1050.3H1050.2V887.3H977.8V977.8H72.4V72.4H977.8V190.1H1050.2V0H36.2V0.0999756Z",
    fill: "url(#paint0_linear_9519_14879)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.403 882.301V948.101H111.503V893.901H111.103L95.7031 903.701V892.801L112.103 882.301H123.503H123.403Z",
    fill: "url(#paint1_linear_9519_14879)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.497 112.701V178.501H111.597V124.301H111.197L95.7969 134.101V123.201L112.197 112.701H123.497ZM166.997 112.701V178.501H155.097V124.301H154.697L139.297 134.101V123.201L155.697 112.701H166.997ZM207.097 179.501C202.297 179.501 198.097 178.701 194.397 177.101C190.697 175.501 187.797 173.301 185.697 170.501C183.597 167.701 182.597 164.501 182.597 161.001C182.597 158.201 183.197 155.701 184.397 153.401C185.597 151.101 187.297 149.201 189.397 147.601C191.497 146.001 193.797 145.001 196.397 144.601V144.101C192.997 143.301 190.297 141.601 188.197 138.901C186.097 136.201 185.097 133.001 185.097 129.501C185.097 126.101 185.997 123.101 187.897 120.401C189.797 117.701 192.397 115.701 195.697 114.101C198.997 112.601 202.797 111.801 207.097 111.801C211.397 111.801 215.097 112.601 218.397 114.101C221.697 115.601 224.297 117.701 226.197 120.401C228.097 123.101 229.097 126.101 229.097 129.501C229.097 132.901 227.997 136.201 225.897 138.901C223.797 141.601 221.097 143.301 217.797 144.101V144.601C220.397 145.001 222.697 146.001 224.697 147.601C226.797 149.101 228.397 151.101 229.697 153.401C230.897 155.701 231.597 158.301 231.597 161.001C231.597 163.701 230.597 167.701 228.397 170.501C226.297 173.301 223.397 175.501 219.697 177.101C215.997 178.701 211.797 179.501 207.097 179.501ZM207.097 170.301C209.597 170.301 211.697 169.901 213.497 169.001C215.297 168.101 216.697 166.901 217.697 165.401C218.697 163.901 219.197 162.101 219.197 160.101C219.197 158.001 218.597 156.101 217.597 154.501C216.597 152.901 215.097 151.601 213.297 150.701C211.497 149.801 209.397 149.301 207.097 149.301C204.797 149.301 202.597 149.801 200.797 150.701C198.997 151.601 197.497 152.901 196.397 154.501C195.297 156.101 194.797 158.001 194.897 160.101C194.897 162.101 195.397 163.901 196.397 165.401C197.397 166.901 198.797 168.101 200.597 169.001C202.397 169.901 204.597 170.301 207.097 170.301ZM207.097 140.301C209.097 140.301 210.897 139.901 212.397 139.101C213.997 138.301 215.197 137.101 216.097 135.701C216.997 134.201 217.497 132.601 217.497 130.701C217.497 128.801 216.997 127.201 216.197 125.701C215.297 124.301 214.097 123.201 212.497 122.401C210.897 121.601 209.097 121.201 207.097 121.201C205.097 121.201 203.197 121.601 201.597 122.401C199.997 123.201 198.797 124.301 197.897 125.701C196.997 127.101 196.597 128.801 196.597 130.701C196.597 132.601 196.997 134.301 197.897 135.701C198.797 137.101 199.997 138.301 201.597 139.101C203.197 139.901 204.997 140.301 206.997 140.301H207.097Z",
    fill: "url(#paint2_linear_9519_14879)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.897 676.102C256.197 665.502 250.397 649.502 247.397 628.002H153.797C153.797 676.802 171.297 715.202 206.297 743.202C241.297 771.002 289.397 784.902 350.497 784.902C411.597 784.902 456.597 770.802 489.297 742.602C522.197 714.202 538.597 678.502 538.597 635.702C538.597 592.902 524.597 562.002 496.597 539.902C478.597 525.702 451.797 514.302 416.397 505.902L335.597 486.502C304.397 479.102 283.997 472.602 274.497 467.102C259.597 458.802 252.197 446.302 252.197 429.602C252.197 412.902 259.697 397.102 274.797 386.902C289.897 376.702 309.997 371.602 335.297 371.602C360.597 371.602 376.997 375.502 392.297 383.402C415.197 395.302 427.497 415.302 429.197 443.602H523.397C521.697 393.702 503.297 355.702 468.297 329.602C433.497 303.302 391.397 290.102 341.897 290.102C292.397 290.102 237.797 304.002 207.297 331.802C176.697 359.602 161.497 394.502 161.497 436.502C161.497 478.502 177.297 516.402 208.897 538.002C227.597 551.002 261.297 562.902 310.097 574.002L359.797 585.102C388.897 591.502 410.197 598.802 423.797 607.102C437.397 615.602 444.197 627.602 444.197 643.102C444.197 669.602 430.497 687.802 403.097 697.502C388.697 702.602 369.897 705.102 346.797 705.102C308.197 705.102 280.897 695.402 264.997 676.102H264.897Z",
    fill: "url(#paint3_linear_9519_14879)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M798.003 515.399C805.003 525.799 809.303 537.499 811.103 550.399H904.003C898.903 500.999 882.503 466.499 854.703 446.999C827.103 427.499 791.603 417.699 748.103 417.699C704.603 417.699 656.903 434.199 627.803 467.399C598.703 500.499 584.203 546.899 584.203 606.499C584.203 666.099 597.403 702.299 623.703 735.399C650.003 768.499 691.103 784.999 746.903 784.999C802.703 784.999 844.803 765.199 873.303 725.499C891.103 700.899 901.103 674.799 903.203 647.199H810.603C808.703 665.499 803.303 680.299 794.403 691.799C785.503 703.299 770.403 708.999 749.203 708.999C728.003 708.999 698.903 694.599 688.103 665.699C682.203 650.199 679.203 629.699 679.203 604.299C679.203 578.899 682.203 556.099 688.103 539.999C699.303 509.699 720.303 494.499 750.803 494.499C781.303 494.499 788.003 501.499 798.203 515.499L798.003 515.399Z",
    fill: "url(#paint4_linear_9519_14879)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M968 384.501H1060V300.801H968V384.501Z",
    fill: "url(#paint5_linear_9519_14879)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 425.898H968V772.798H1060V425.898Z",
    fill: "url(#paint6_linear_9519_14879)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1581.1 427.201C1566.2 421.301 1551.2 418.301 1535.9 418.301C1513 418.301 1492.2 423.101 1473.5 432.601C1455.9 442.201 1441.1 457.101 1429.3 477.501C1422.5 460.501 1412.5 446.601 1399.4 435.801C1383.1 424.101 1361.6 418.301 1335.1 418.301C1308.6 418.301 1284.3 425.101 1266.7 438.701C1256.7 446.301 1246.1 459.201 1234.9 477.201V426.601H1146.7V772.901H1238.7V564.101C1238.7 545.201 1241.1 531.001 1246 521.401C1254.9 504.601 1272.3 496.301 1298.2 496.301C1324.1 496.301 1335.4 504.701 1343.1 521.401C1347.3 530.701 1349.5 545.701 1349.5 566.301V772.901H1440.9V566.301C1440.9 550.801 1443.3 537.501 1448.2 526.501C1457.8 505.701 1475 495.301 1500.1 495.301C1525.2 495.301 1536.6 503.401 1544.7 519.501C1548.9 528.001 1551.1 538.801 1551.1 552.001V772.901H1644L1644.6 554.201C1644.6 531.701 1643.5 514.601 1641.4 503.001C1638 485.401 1631.4 470.501 1621.7 458.401C1609.6 443.601 1596.1 433.201 1581.3 427.201H1581.1Z",
    fill: "url(#paint7_linear_9519_14879)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2018.4 463.201C1990.4 433.301 1956.1 418.301 1915.6 418.301C1875.1 418.301 1863.8 426.001 1843.7 441.501C1832.7 450.201 1822.3 462.101 1812.5 477.201V426.001H1725.6V909.501H1815.4V728.701C1824.9 743.301 1834.7 754.501 1844.7 762.101C1862.9 775.901 1885.9 782.801 1913.5 782.801C1956.8 782.801 1992.1 766.801 2019.5 734.701C2047.1 702.701 2060.9 656.101 2060.9 595.001C2060.9 533.901 2046.8 493.101 2018.6 463.201H2018.4ZM1948.7 528.401C1961 549.001 1967.2 572.601 1967.2 599.401C1967.2 626.201 1960.5 657.901 1947.1 677.401C1933.9 696.901 1914.7 706.701 1889.5 706.701C1864.3 706.701 1857 701.901 1844.3 692.401C1822.9 676.101 1812.1 647.701 1812.1 607.401C1812.1 567.101 1815.3 560.901 1821.7 544.401C1834 513.201 1856.6 497.601 1889.5 497.601C1922.4 497.601 1936.6 507.901 1948.7 528.501V528.401Z",
    fill: "url(#paint8_linear_9519_14879)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2128.5 772.899H2219.2V303.699H2128.5V772.899Z",
    fill: "url(#paint9_linear_9519_14879)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2309.3 384.501H2401.3V300.801H2309.3V384.501Z",
    fill: "url(#paint10_linear_9519_14879)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2401.3 425.898H2309.3V772.798H2401.3V425.898Z",
    fill: "url(#paint11_linear_9519_14879)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2636.5 299.498C2630.8 299.098 2625.1 298.898 2619.6 298.898C2574.6 298.898 2544.8 307.398 2530.2 324.398C2513.9 342.398 2505.7 369.898 2505.7 406.798V429.098H2456V493.098H2506.6V772.898H2597V493.098H2656.5V429.098H2597V422.698C2596.6 405.898 2597.9 393.598 2601.1 385.798C2604.3 377.898 2613 373.998 2627.2 373.998C2641.4 373.998 2637.8 374.098 2641.8 374.298C2645.8 374.298 2650 374.398 2654.2 374.598V300.798C2648.1 300.398 2642.1 299.998 2636.4 299.498H2636.5Z",
    fill: "url(#paint12_linear_9519_14879)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2956.8 430.998L2929.1 523.798C2921.5 548.298 2914.5 570.298 2908.1 590.598C2894.4 633.598 2883.3 668.598 2874.3 702.198C2860.8 650.198 2846.9 606.698 2832.2 560.898C2828.3 548.598 2824.2 535.998 2820.2 523.098L2792.5 430.998H2702.7L2801.7 717.798C2812.3 747.498 2817.5 770.598 2817.5 786.398C2817.5 802.198 2812.2 816.098 2803 825.998C2793.1 836.598 2779.2 841.198 2761.4 841.198H2729.7V906.498C2740.3 907.798 2752.1 908.498 2766 908.498C2806.9 908.498 2837.9 901.198 2859.7 886.098C2880.8 871.598 2898 845.198 2912.5 806.198L3043.8 430.898H2956.7L2956.8 430.998Z",
    fill: "url(#paint13_linear_9519_14879)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3134.8 429.599C3169.15 429.599 3197 401.751 3197 367.399C3197 333.047 3169.15 305.199 3134.8 305.199C3100.45 305.199 3072.6 333.047 3072.6 367.399C3072.6 401.751 3100.45 429.599 3134.8 429.599Z",
    stroke: "url(#paint14_linear_9519_14879)",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3163.8 392.801C3163.8 396.101 3164.6 398.801 3165.9 400.801H3152.4C3151.2 398.901 3150.6 396.101 3150.6 392.601L3150.3 385.001C3150.1 380.801 3149.2 377.901 3147.4 376.201C3145.7 374.601 3143 373.701 3139.2 373.701H3122.2V400.701H3109.1V331.801H3140.4C3148.1 331.801 3154.1 333.501 3158.3 337.001C3162.6 340.501 3164.7 345.201 3164.7 351.201C3164.7 357.201 3160.9 364.901 3153.2 367.701C3156.7 368.801 3159.2 370.501 3160.7 372.901C3162.2 375.301 3163 378.401 3163.2 382.401L3163.8 392.701V392.801ZM3122.3 363.601H3139.7C3143.4 363.601 3146.2 362.701 3148.3 360.801C3150.3 359.001 3151.4 356.301 3151.4 352.801C3151.4 349.301 3150.4 347.001 3148.3 345.201C3146.2 343.501 3143.2 342.601 3139.3 342.601H3122.4V363.501L3122.3 363.601Z",
    fill: "url(#paint15_linear_9519_14879)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9519_14879",
    x1: -240.5,
    y1: -200.7,
    x2: 1213.8,
    y2: 1178.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04D8BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9519_14879",
    x1: 76.3031,
    y1: 900.801,
    x2: 149.903,
    y2: 926.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04D8BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9519_14879",
    x1: 106.597,
    y1: 76.8008,
    x2: 222.797,
    y2: 212.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04D8BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9519_14879",
    x1: 123.297,
    y1: 494.302,
    x2: 3069.8,
    y2: 1076.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9519_14879",
    x1: 126.403,
    y1: 478.499,
    x2: 3072.9,
    y2: 1060.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9519_14879",
    x1: 185.6,
    y1: 179.101,
    x2: 3132.1,
    y2: 761.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9519_14879",
    x1: 136.8,
    y1: 426.098,
    x2: 3083.3,
    y2: 1008.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9519_14879",
    x1: 150.003,
    y1: 359.201,
    x2: 3096.5,
    y2: 941.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9519_14879",
    x1: 155.101,
    y1: 333.401,
    x2: 3101.6,
    y2: 915.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9519_14879",
    x1: 192.001,
    y1: 146.799,
    x2: 3138.5,
    y2: 728.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9519_14879",
    x1: 235.997,
    y1: -75.8992,
    x2: 3182.5,
    y2: 506.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9519_14879",
    x1: 187.197,
    y1: 171.098,
    x2: 3133.7,
    y2: 753.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9519_14879",
    x1: 207.5,
    y1: 68.0984,
    x2: 3154,
    y2: 650.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9519_14879",
    x1: 193.902,
    y1: 136.898,
    x2: 3140.4,
    y2: 718.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9519_14879",
    x1: 3067.6,
    y1: 367.399,
    x2: 3202,
    y2: 367.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9519_14879",
    x1: 3255.2,
    y1: 380.301,
    x2: 3015.4,
    y2: 354.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScimplifyLogo8A1Aba1D);
export default __webpack_public_path__ + "static/media/Scimplify Logo.8a1aba1d.90f8e174cbf6001c3989cfc0e99f0d18.svg";
export { ForwardRef as ReactComponent };